import { createReducer, createActions } from "reduxsauce";
import { BIDDER_STATUS } from "../themes/cashrent/common/index";

const { Types, Creators } = createActions({
  fetchAuditData: ["data"],
  fetchAuditDataFailure: null,
  fetchAuditDataSuccess: ["data"],
  addListingWatch: ["id"],
  addListingBid: ["id"],
  removeListingWatch: ["id"],
  cleanData: null,
});

export const AuditTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = {
  watchList: [],
  bidList: [],
  bidderList: {
    [BIDDER_STATUS.DENIED]: [],
    [BIDDER_STATUS.SUSPENDED]: [],
    [BIDDER_STATUS.PENDING]: [],
    [BIDDER_STATUS.REGISTERED]: [],
  },
  isFetching: false,
};

/* ------------- Selectors ------------- */

export const AuditSelectors = {
  bidderList: (state) => state.audit.bidderList,
};

/* ------------- Reducers ------------- */

export const fetchAuditData = (state = INITIAL_STATE) => ({
  ...state,
  isFetching: true,
});

export const fetchAuditDataFailure = () => INITIAL_STATE;

export const fetchAuditDataSuccess = (state = INITIAL_STATE, action) => {
  const { data } = action;

  return {
    ...state,
    ...data,
    isFetching: false,
  };
};
export const addListingWatch = (state = INITIAL_STATE, action) => {
  const { watchList } = state;
  const { id } = action;

  return {
    ...state,
    watchList: [...watchList, id],
  };
};

export const removeListingWatch = (state = INITIAL_STATE, action) => {
  const { watchList } = state;
  const { id } = action;
  const ids = watchList.filter((list) => list !== id);

  return {
    ...state,
    watchList: ids,
  };
};

export const cleanData = () => INITIAL_STATE;

export const addListingBid = (state = INITIAL_STATE, action) => {
  const { bidList } = state;
  const { id } = action;

  return {
    ...state,
    bidList: bidList.findIndex((i) => i === id) > -1 ? [...bidList] : [...bidList, id],
  };
};

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.FETCH_AUDIT_DATA]: fetchAuditData,
  [Types.FETCH_AUDIT_DATA_FAILURE]: fetchAuditDataFailure,
  [Types.FETCH_AUDIT_DATA_SUCCESS]: fetchAuditDataSuccess,
  [Types.ADD_LISTING_WATCH]: addListingWatch,
  [Types.ADD_LISTING_BID]: addListingBid,
  [Types.REMOVE_LISTING_WATCH]: removeListingWatch,
  [Types.CLEAN_DATA]: cleanData,
});
